<template>
  <div class="fadeIn">
    <div class="ra-auth--form__header">
      <h6>Hello {{ updateData.name }}</h6>
      <p>Setup your password.</p>
    </div>
    <div class="ra-auth--form__form">
      <el-form :rules="formRules" :model="form" label-position="top" ref="form">
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item label="Password" prop="password">
              <el-input type="password" v-model="form.password" show-password>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item label="Confirm Password" prop="confirmPassword">
              <el-input
                type="password"
                v-model="form.confirmPassword"
                show-password
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="ra-auth--form__actions">
      <el-button :loading="loading" type="primary" @click="updatePassword"
        >Update</el-button
      >
    </div>
  </div>
</template>

<script>
import { currentUser } from "@/lib/utils";
import apiConstants from "@/apiConstants";

export default {
  name: "UpdatePassword",
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error("Password doesn't match"));
      } else {
        callback();
      }
    };

    return {
      noAccessCodes: apiConstants.NO_ACCESS_CODES,
      loading: false,
      form: {
        password: "",
        confirmPassword: ""
      },
      formRules: {
        password: [
          {
            required: true,
            message: "Password is required",
            trigger: "change"
          },
          {
            min: 5,
            message: "Minimum 5 characters long",
            trigger: "change"
          }
        ],
        confirmPassword: [
          {
            required: true,
            message: "Confirm password",
            trigger: "change"
          },
          {
            validator: validateConfirmPassword,
            trigger: ["blur", "change"]
          }
        ]
      },
      updateData: {
        auth_token: null,
        name: "",
        email: ""
      }
    };
  },

  methods: {
    updatePassword() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return false;
        }

        this.loading = true;
        this.$http
          .post(
            "auth/local/password",
            {
              body: this.form,
              method: "POST"
            },
            {
              headers: {
                "Api-Token": this.updateData.auth_token
              }
            }
          )
          .then(response => {
            const resData = response.data;
            if (resData.status === "error") {
              this.loading = false;
              this.handleErrors(resData);
            } else {
              this.notification(
                "Password Updated",
                "Your password has been updated successfully!",
                "success"
              );
              this.$router.push({ name: "login" });
              sessionStorage.removeItem("radius-update-data");
            }
          })
          .catch(() => {
            this.loading = false;
            this.notification("Error", "An unknown error occurred", "danger");
          });
      });
    }
  },

  mounted() {
    const data = sessionStorage.getItem("radius-update-data");
    if (!data) {
      this.notification("Invalid Request", "Please create an account", "info");
      this.$router.push({ name: "register" });
      return;
    }

    this.updateData = data && JSON.parse(data);
  },

  beforeRouteEnter(to, from, next) {
    if (currentUser()) {
      this.$router.push({ name: "home.index" });
    } else {
      next();
    }
  }
};
</script>
